var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "agent-activity-chart w-100" }, [
    _c(
      "div",
      { staticClass: "time-ticks" },
      _vm._l(_vm.getTicks(), function (tick) {
        return _c("div", {
          staticClass: "tick",
          class: { big: tick.isBig, bold: tick.isBold },
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "chart" }, [
      _c(
        "div",
        { staticClass: "bars" },
        _vm._l(_vm.percents, function (percent) {
          return _c("div", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "top-right" },
                expression: "{ followCursor: true, placement: 'top-right' }",
              },
            ],
            staticClass: "bar",
            class: {
              accepting: percent.isAcceptingChat,
              notaccepting: percent.isNotAcceptingChat,
              offline: percent.isLoggedOut,
            },
            style: _vm.calculateStyle(percent),
            attrs: { content: _vm.calculateTippyContent(percent) },
          })
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "status d-flex justify-content-center" }, [
      _c(
        "div",
        { staticClass: "d-flex mr-2" },
        [
          _c("a-badge", { attrs: { color: "green" } }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.acceptingChat")) +
              ":\n            "
          ),
          _c("strong", { staticClass: "ml-2" }, [
            _vm._v(
              _vm._s(_vm.humanizeDuration(_vm.status.acceptingChatDuration))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex mr-2" },
        [
          _c("a-badge", { attrs: { color: "red" } }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.notAcceptingChat")) +
              ":\n            "
          ),
          _c("strong", { staticClass: "ml-2" }, [
            _vm._v(
              _vm._s(_vm.humanizeDuration(_vm.status.notAcceptingChatDuration))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex mr-2" },
        [
          _c("a-badge", { attrs: { color: "gray" } }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.loggedOut")) +
              ":\n            "
          ),
          _c("strong", { staticClass: "ml-2" }, [
            _vm._v(_vm._s(_vm.humanizeDuration(_vm.status.loggedOutDuration))),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }